import classNames from 'classnames';
import { List } from 'immutable';
import { debounce, isFunction, isString } from 'lodash';
import { useState } from 'react';

import { AUTH_INPUT_DEBOUNCE_TIME } from '@alkem/micro-frontend-tools';

import './text-input.scss';
import { AuthFormTooltipError } from './tooltip-error';

type Props = {
  id: string;
  placeholder?: string;
  name?: string;
  formKey: string;
  value: string | number | null;
  isPassword?: boolean;
  error?: boolean | List<any>;
  errorMessage?: string;
  minLength?: number;
  maxLength?: number;
  disabled?: boolean;
  onChange: (value?: any) => void;
};

const AuthFormTextInput = ({
  id,
  placeholder,
  name,
  error,
  errorMessage,
  disabled,
  formKey,
  onChange,
  isPassword = false,
  maxLength = 255,
  minLength = 8,
  ...props
}: Props) => {
  const [value, setValue] = useState<string | number | null>(null);
  const [hasFocus, setFocus] = useState(false);
  const [hasMouse, setMouse] = useState(false);

  const triggerChange = debounce((_value) => {
    if (isFunction(onChange)) {
      onChange({ formKey, value: _value });
    }
  }, AUTH_INPUT_DEBOUNCE_TIME);

  const _onChange = (event) => {
    if (disabled) {
      return;
    }
    const { value: _value } = event.target;
    setValue(_value);
    triggerChange(_value);
  };

  const showTooltip = error && (hasFocus || hasMouse);
  const inputValue = isString(value) ? value : props.value || '';
  return (
    <>
      <input
        id={id}
        data-testid={id}
        className={classNames(
          'AuthFormTextInput',
          error && 'AuthFormTextInput--invalid',
          disabled && 'AuthFormTextInput--disabled',
        )}
        type={isPassword ? 'password' : 'text'}
        placeholder={placeholder}
        value={inputValue}
        name={name}
        maxLength={maxLength}
        minLength={minLength}
        disabled={disabled}
        onChange={_onChange}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        onMouseEnter={() => setMouse(true)}
        onMouseLeave={() => setMouse(false)}
        data-auth-form-error={`${!!error}`}
      />
      {showTooltip && (
        <AuthFormTooltipError error={error}>
          {errorMessage}
        </AuthFormTooltipError>
      )}
    </>
  );
};

export default AuthFormTextInput;
